'use client'
import Image from "next/image";
import { useState } from "react";
import styles from "./header.module.css";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const navLink =
    "block w-full text-left whitespace-nowrap leading-[1.4] font-medium tracking-[1px] " +
    "transition-colors duration-200 border-b border-[rgba(245,244,238,0.3)] py-4 px-4 " +
    "xl:border-none xl:w-auto xl:uppercase xl:tracking-[2px] xl:text-white xl:text-[.85rem] xl:py-2 xl:px-4 " +
    "xl:hover:bg-[rgba(245,244,238,0.16)] xl:focus:bg-[rgba(245,244,238,0.16)]";

  return (
    <header className={`${styles.header} bg-primary-700`}>
      <a className={styles.header__logo} aria-label="Homepage" href="/">
        <Image src="/bebop/img/logo.png" width={50} height={50} alt="Logo de la página" />
      </a>

      {/* CTA mobile visible; oculta en xl */}
      <a className={`${styles.cta} ${styles.boton_especial} xl:hidden`} href="/#home-content">
        Comprar Tickets
      </a>

      {/* Burger visible en mobile; oculto en xl */}
      <button
        className={`${styles.burger_button} xl:hidden`}
        id="menu-toggle"
        aria-label="Toggle menu"
        aria-expanded={isOpen}
        aria-controls="header__nav"
        onClick={() => setIsOpen((v) => !v)}
      />

      {/* Nav: en mobile es overlay condicional; en desktop (xl) siempre visible */}
      <nav
        id="header__nav"
        aria-label="Primary navigation"
        className={`${isOpen ? styles.menuOverlay : "hidden"} xl:block`}
        onClick={() => setIsOpen(false)}
      >
        <ul className="flex flex-col w-full text-left xl:flex-row xl:items-center xl:w-auto xl:gap-1">
          <li className={styles.header__nav_item}>
            <a className={navLink} href="/#home-content">Shows</a>
          </li>
          <li className={`${styles.header__nav_item} ${styles.cta}`}>
            <a className={navLink} href="/#home-content">Comprar tickets</a>
          </li>
          <li className={styles.header__nav_item}>
            <a className={navLink} href="/#elClub">BEBOP CLUB</a>
          </li>
          <li className={styles.header__nav_item}>
            <a className={navLink} href="/bebop/carta/CartaBebopActualizada.pdf">Menú</a>
          </li>
          <li className={styles.header__nav_item}>
            <a className={navLink} href="/faq">Preguntas frecuentes</a>
          </li>
        </ul>
      </nav>
    </header>
  );
}
